import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Historial} from "./historial";
import {HistorialService} from "../Services/historial.service";

@Component({
  selector: 'app-historial',
  templateUrl: './historial.component.html',
  styleUrls: ['./historial.component.css']
})
export class HistorialComponent implements OnInit {
  msgs: Message[] = [];
  formHistorial : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  tiposDocumento = [];
  panelRequeridos = false;
  loading = false;
  HistorialsRegistrados:Historial[];
  HistorialSeleccionado:Historial;
  tipoGuardado = '';


  constructor(private servicioHistorial:HistorialService,private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesHistorial();
    this.Cancelar();
    this.poblarTiposDoc();
    this.listarHistorials();
  }

  crearControlesHistorial(){
    this.formHistorial = this.fb.group({
      usuario_id:['',Validators.required],
      descripcionMovimiento:['',Validators.required],
      }
    );

  }
  nuevoHistorial(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formHistorial.enable();
    this.formHistorial.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formHistorial.reset();
    this.formHistorial.disable();
    this.panelRequeridos = false;
  }
  poblarTiposDoc(){
    this.tiposDocumento.push({label:'Seleccione un Tipo', value:''});
    this.tiposDocumento.push({label:'C.C', value:'C.C'});
    this.tiposDocumento.push({label:'PASAPORTE', value:''});
    this.tiposDocumento.push({label:'C.E.', value:''});
    this.tiposDocumento.push({label:'DNI', value:''});
    this.tiposDocumento.push({label:'NIT', value:''});
    this.tiposDocumento.push({label:'NUIP', value:''});
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoHistorial(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioHistorial.putHistorial(this.formHistorial.value,this.HistorialSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarHistorials();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioHistorial.addHistorial(this.formHistorial.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarHistorials();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarHistorials(){
    this.loading = true;
    this.servicioHistorial.getHistorial()
      .subscribe(
        rt => {
          this.HistorialsRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarHistorial(item:Historial){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formHistorial.enable();
    this.panelRequeridos = true;
    this.HistorialSeleccionado = item;
    this.HistorialDetalle(item);
    this.tipoGuardado = 'editar';
  }
  HistorialDetalle(item:Historial):void {
   this.formHistorial.patchValue({
   id:item.id,
   nombre:item.usuario_id,
   precioCompra:item.descripcionMovimiento,
   });
   }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/historial/historial.component.ts